import Icon from '@mui/material/Icon'

import { UIconProps } from './type'

export function UIcon({
  color = 'primary',
  name,
  fontSize,
  className,
  ...props
}: UIconProps) {
  const isExtraLarge = fontSize === 'extraLarge'

  return (
    <Icon
      color={color}
      fontSize={isExtraLarge ? undefined : fontSize}
      className={
        isExtraLarge
          ? `MuiIcon-fontSizeExtraLarge ${className ?? ''}`
          : className
      }
      {...props}
    >
      {name}
    </Icon>
  )
}
